<template>
  <div class="showMemo">
    <div class="memo" v-html="memo"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memo: this.$route.query.memo,
    };
  },
};
</script>

<style lang="scss" scoped>
.showMemo {
  .memo {
    /deep/img {
      max-width: 100%;
    }
    /deep/p,
    span {
      font-size: 0.28rem;
    }
    /deep/ video {
      max-width: 100%;
      border: none;
      text-decoration: none;
    }
  }
  font-family: "huakang";
}
</style>